import { render, staticRenderFns } from "./BasePriority.vue?vue&type=template&id=3c1c9d06&scoped=true&lang=pug&"
import script from "./BasePriority.vue?vue&type=script&lang=js&"
export * from "./BasePriority.vue?vue&type=script&lang=js&"
import style0 from "./BasePriority.vue?vue&type=style&index=0&id=3c1c9d06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c9d06",
  null
  
)

export default component.exports